import { render, staticRenderFns } from "./MonthBreadcrumbs.vue?vue&type=template&id=6efe5a52&scoped=true&"
import script from "./MonthBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./MonthBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe5a52",
  null
  
)

export default component.exports